import { submitApplication } from 'fmc-sdk';
import { useSelector } from 'react-redux';
import useInstantCredit from 'hooks/requests/instantCredit';
import { selectCreditApplication } from 'state/creditApplication';
import useNavigationHelpers from 'hooks/useNavigationHelpers';
import useFmcHost from 'hooks/useFmcHost';
import { useCallback } from 'react';
import useAnalytics, { Event } from 'hooks/useAnalytics';

import { FormValues } from './UnifiedCreditApplicationReview';

const useApplyInstantCredit = () => {
  const application = useSelector(selectCreditApplication);
  const [applyInstantCredit] = useInstantCredit();

  const { push } = useNavigationHelpers();
  const fmcDispatch = useFmcHost();
  const { sendEvents } = useAnalytics();

  const applyForCredit = useCallback(
    async (params: FormValues) => {
      fmcDispatch(submitApplication());
      const payload = {
        ...application,
        ...params,
      };
      if (!params.reCaptchaToken) return;
      const { hasExistingAccount, isApproved } = await applyInstantCredit(
        payload,
        params.reCaptchaToken,
      );

      if (!isApproved) {
        push('/credit-pending');
      } else {
        if (hasExistingAccount) {
          push('/existing-account');
        } else {
          sendEvents([Event.ApplicationApproved, Event.ApplicationCompleted]);
          push('/approval');
        }
      }
    },
    [applyInstantCredit, application, push, fmcDispatch, sendEvents],
  );
  return applyForCredit;
};

export default useApplyInstantCredit;
